
// src/redux/store.js
import { configureStore } from '@reduxjs/toolkit';
import userReducer from './slices/user';
import projectReducer from './slices/product';
import componentReducer from './slices/component';


const store = configureStore({
  reducer: {
    user: userReducer,
    project: projectReducer,
    component: componentReducer
  },
});

export default store;